import { createContext, type ElementType, useContext } from 'react'

/**
 * UI components never import the router. The app passes its link component
 * (a react-router Link that accepts `href`) once, through `LinkProvider`.
 */
const LinkContext = createContext<ElementType>('a')

export const LinkProvider = LinkContext.Provider

/**
 * Typed as `'a'`: the link component takes the same props as an anchor (`href`, …). A menu's links (the side menu,
 * the bottom bar) carry `data-menu`: the page is opened as a menu item, which on a phone keeps a stack of its own.
 */
export function useLinkComponent(): 'a' {
  return useContext(LinkContext) as 'a'
}

/**
 * Spread on links to other sites, and to a page meant for another screen (a clock-in display): they open in a
 * new tab or window (in an installed app on iPhone, a sheet over it), so the app stays put. See docs/pwa.md.
 * Links to another app of Thananan OS do not: it loads in place, and Back returns.
 * Phone and e-mail links (`tel:`, `mailto:`) hand off to the phone's own apps.
 */
export const newWindow = { target: '_blank', rel: 'noopener' } as const
